import { DataTable } from "../../../data-table.interface";
import { PickingAudit } from "../../../../../../core";

const iconsOfActionsList = [
  {
    icon: 'printer',
    tooltip: 'Imprimir etiqueta',
    hasVisibleCondition: (element: any[]) => {
      return true;
    }
  },
  {
    icon: 'confirm-multiple-audit',
    tooltip: 'Confirmar',
    hasVisibleCondition: (containers: PickingAudit[]) => {
      const hasContainerAudited = containers.find(container=>container.isAudited);
      return hasContainerAudited? false : true;
    }
  }
];

export const pickingAudit:DataTable = {
    searchText: "",
    addText: "",
    checkbox: true,
    expandable: true,
    paginator: true,
    export: false,
    exportAllData: true,
    iconsOfActions: iconsOfActionsList,
    exportFile: 'reporte_auditoria_picking.xlsx',
    columns: [
      {
        title: "Jaba",
        name: "containerCode",
        type: "string",
        editable: false,
        checkAll: false,
        value: (element: PickingAudit) => element.containerCode,
      },
      {
        title: "Despacho",
        name: "serialNumber",
        type: "string",
        editable: false,
        checkAll: false,
        value: (element: PickingAudit) => element.serialNumber,
      },
      {
        title: "Cantidad total",
        name: "amountTotalJaba",
        type: "string",
        editable: false,
        checkAll: false,
        class: "center",
        value: (element: PickingAudit) => element.amountTotalJaba,
      },
      {
        title: "Fecha de creación",
        name: "createdAt",
        type: "string",
        editable: false,
        checkAll: false,
        value: (element: PickingAudit) => element.createdAt,
      },
      {
        title: "Tipo de doc.",
        name: "documentType",
        type: "string",
        editable: false,
        checkAll: false,
        value: (element: PickingAudit) => element.customer? element.customer.documentType :'',
      },
      {
        title: "N° de doc.",
        name: "identityDocument",
        type: "string",
        editable: false,
        checkAll: false,
        value: (element: PickingAudit) => element.customer? element.customer.identityDocument :'',
      },
      {
        title: "Cliente",
        name: "fullName",
        type: "string",
        editable: false,
        checkAll: false,
        value: (element: PickingAudit) => element.customer? element.customer.fullName :'',
      },
      {
        title: "Auditado",
        name: "isAudited",
        type: "string",
        class: "center",
        editable: false,
        checkAll: false,
        value: (element: PickingAudit) => element.isAudited? 'SI':'NO',
      },
    ],
  };
